<div class="card">
  <app-header
    titulo="Pagamentos Integrados"
    descricao="Pagamentos que já foram integrados"
  ></app-header>

  <app-processamentocontrato statusParcela="importado"></app-processamentocontrato>

</div>
